import { Inject, Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { merge } from 'lodash-es';
import { AppConfig } from './app.config';

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private _config: BehaviorSubject<AppConfig>;

  constructor(@Inject(APP_CONFIG) config: AppConfig) {
    this._config = new BehaviorSubject(config);
  }

  /**
   * Setter & getter for config
   */
  set config(value: AppConfig) {
    // Merge the new config over to the current config
    const config = merge({}, this._config.getValue(), value);

    // Execute the observable
    this._config.next(config);
  }

  get config$(): Observable<AppConfig> {
    return this._config.asObservable();
  }

  /**
   * Resets the config to the default
   */
  reset(): void {
    // Set the config
    this._config.next(this.config);
  }
}
